"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionTableRow = exports.StyledOpenColumn = exports.IconContainer = exports.ExpandedRow = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var globalVars_module_scss_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/globalVars.module.scss"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Row = styled_components_1.default.tr.attrs({
    className: 'tws-table-row',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder-top: 0px;\n\theight: 75px;\n\t&.drawer-open > td {\n\t\t&.tws-table-row-drawer-toggle {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t\t&:not(.tws-table-row-drawer-toggle) {\n\t\t\tbackground-color: #dfebef;\n\t\t}\n\t}\n"], ["\n\tborder-top: 0px;\n\theight: 75px;\n\t&.drawer-open > td {\n\t\t&.tws-table-row-drawer-toggle {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t\t&:not(.tws-table-row-drawer-toggle) {\n\t\t\tbackground-color: #dfebef;\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.mainBlue);
Row.displayName = 'Row';
exports.ExpandedRow = styled_components_1.default.tr.attrs({
    className: 'tws-table-row-drawer',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\t&.tws-table-row-drawer td .tws-table-row-drawer-container {\n\t\tmargin: 10px 0 20px 0;\n\t}\n\t& > td.tws-table-column {\n\t\tpadding-bottom: 0;\n\t\tpadding-top: 15px;\n\t\t& > div {\n\t\t\tborder-top: 1px dashed ", ";\n\t\t}\n\t}\n"], ["\n\tbackground-color: ", ";\n\t&.tws-table-row-drawer td .tws-table-row-drawer-container {\n\t\tmargin: 10px 0 20px 0;\n\t}\n\t& > td.tws-table-column {\n\t\tpadding-bottom: 0;\n\t\tpadding-top: 15px;\n\t\t& > div {\n\t\t\tborder-top: 1px dashed ", ";\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.secondaryGray2);
exports.ExpandedRow.displayName = 'ExpandedRow';
exports.IconContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: white;\n"], ["\n\tcolor: white;\n"])));
exports.IconContainer.displayName = 'IconContainer';
exports.StyledOpenColumn = styled_components_1.default.td.attrs({
    className: 'tws-table-row-drawer-toggle',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tborder-bottom-left-radius: 3px;\n\tborder-top-left-radius: 3px;\n\tbackground-color: ", ";\n\tvertical-align: middle !important;\n\ttext-align: center;\n\tcursor: pointer;\n\ttable-layout: fixed;\n\twidth: 50px;\n\tmin-width: 50px;\n"], ["\n\tborder-bottom-left-radius: 3px;\n\tborder-top-left-radius: 3px;\n\tbackground-color: ", ";\n\tvertical-align: middle !important;\n\ttext-align: center;\n\tcursor: pointer;\n\ttable-layout: fixed;\n\twidth: 50px;\n\tmin-width: 50px;\n"])), globalVars_module_scss_1.default.tertiaryBlue2);
var DimensionTableRow = /** @class */ (function (_super) {
    __extends(DimensionTableRow, _super);
    function DimensionTableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selected: _this.props.selected,
        };
        return _this;
    }
    DimensionTableRow.prototype.render = function () {
        var _a = this.props, children = _a.children, isOpen = _a.isOpen, record = _a.record, OnOpen = _a.OnOpen;
        var openIconName = isOpen ? 'angle-up' : 'angle-down';
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, __assign({}, this.props, { className: isOpen ? 'drawer-open' : '' }),
                React.createElement(exports.StyledOpenColumn, { onClick: OnOpen },
                    React.createElement(exports.IconContainer, null,
                        React.createElement(aon_tws_common_ui_1.Icon, { name: openIconName }))),
                children),
            this.renderExpandRow(record)));
    };
    DimensionTableRow.prototype.renderExpandRow = function (record) {
        var _a = this.props, expanded = _a.expanded, expandedRowRender = _a.expandedRowRender;
        if (expandedRowRender) {
            return expanded && React.createElement(exports.ExpandedRow, null, expandedRowRender(record));
        }
        return null;
    };
    return DimensionTableRow;
}(React.Component));
exports.DimensionTableRow = DimensionTableRow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
